var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var dfn = require('@netlify/open-api');

var pWaitFor = require('p-wait-for');

var _deploy = require('./deploy');

var _require = require('./methods'),
    getMethods = _require.getMethods;

var _require2 = require('./operations'),
    getOperations = _require2.getOperations;
/* eslint-disable fp/no-this */
// eslint-disable-next-line fp/no-class


var NetlifyAPI =
/*#__PURE__*/
function () {
  "use strict";

  function NetlifyAPI(firstArg, secondArg) {
    _classCallCheck(this, NetlifyAPI);

    // variadic arguments
    var _ref = typeof firstArg === 'object' ? [null, firstArg] : [firstArg, secondArg],
        _ref2 = _slicedToArray(_ref, 2),
        accessTokenInput = _ref2[0],
        _ref2$ = _ref2[1],
        opts = _ref2$ === void 0 ? {} : _ref2$; // default opts


    var _opts$userAgent = opts.userAgent,
        userAgent = _opts$userAgent === void 0 ? 'netlify/js-client' : _opts$userAgent,
        _opts$scheme = opts.scheme,
        scheme = _opts$scheme === void 0 ? dfn.schemes[0] : _opts$scheme,
        _opts$host = opts.host,
        host = _opts$host === void 0 ? dfn.host : _opts$host,
        _opts$pathPrefix = opts.pathPrefix,
        pathPrefix = _opts$pathPrefix === void 0 ? dfn.basePath : _opts$pathPrefix,
        _opts$accessToken = opts.accessToken,
        accessToken = _opts$accessToken === void 0 ? accessTokenInput : _opts$accessToken,
        _opts$globalParams = opts.globalParams,
        globalParams = _opts$globalParams === void 0 ? {} : _opts$globalParams,
        agent = opts.agent;
    var defaultHeaders = {
      'User-agent': userAgent,
      accept: 'application/json'
    };
    var basePath = getBasePath({
      scheme: scheme,
      host: host,
      pathPrefix: pathPrefix
    });
    var methods = getMethods({
      basePath: basePath,
      defaultHeaders: defaultHeaders,
      agent: agent,
      globalParams: globalParams
    }); // eslint-disable-next-line fp/no-mutating-assign

    Object.assign(this, _objectSpread({}, methods, {
      defaultHeaders: defaultHeaders,
      scheme: scheme,
      host: host,
      pathPrefix: pathPrefix,
      globalParams: globalParams,
      accessToken: accessToken,
      agent: agent
    }));
  }

  _createClass(NetlifyAPI, [{
    key: "getAccessToken",
    value: function () {
      var _getAccessToken = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(ticket) {
        var _this = this;

        var _ref3,
            _ref3$poll,
            poll,
            _ref3$timeout,
            timeout,
            id,
            authorizedTicket,
            checkTicket,
            accessTokenResponse,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref3 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, _ref3$poll = _ref3.poll, poll = _ref3$poll === void 0 ? DEFAULT_TICKET_POLL : _ref3$poll, _ref3$timeout = _ref3.timeout, timeout = _ref3$timeout === void 0 ? DEFAULT_TICKET_TIMEOUT : _ref3$timeout;
                id = ticket.id; // ticket capture

                checkTicket =
                /*#__PURE__*/
                function () {
                  var _ref4 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee() {
                    var t;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return _this.showTicket({
                              ticketId: id
                            });

                          case 2:
                            t = _context.sent;

                            if (t.authorized) {
                              authorizedTicket = t;
                            }

                            return _context.abrupt("return", Boolean(t.authorized));

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, this);
                  }));

                  return function checkTicket() {
                    return _ref4.apply(this, arguments);
                  };
                }();

                _context2.next = 5;
                return pWaitFor(checkTicket, {
                  interval: poll,
                  timeout: timeout,
                  message: 'Timeout while waiting for ticket grant'
                });

              case 5:
                _context2.next = 7;
                return this.exchangeTicket({
                  ticketId: authorizedTicket.id
                });

              case 7:
                accessTokenResponse = _context2.sent;
                // See https://open-api.netlify.com/#/default/exchangeTicket for shape
                this.accessToken = accessTokenResponse.access_token;
                return _context2.abrupt("return", accessTokenResponse.access_token);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAccessToken(_x) {
        return _getAccessToken.apply(this, arguments);
      }

      return getAccessToken;
    }()
  }, {
    key: "deploy",
    value: function () {
      var _deploy2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(siteId, buildDir, opts) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.accessToken) {
                  _context3.next = 2;
                  break;
                }

                throw new Error('Missing access token');

              case 2:
                _context3.next = 4;
                return _deploy(this, siteId, buildDir, opts);

              case 4:
                return _context3.abrupt("return", _context3.sent);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deploy(_x2, _x3, _x4) {
        return _deploy2.apply(this, arguments);
      }

      return deploy;
    }()
  }, {
    key: "accessToken",
    get: function get() {
      var Authorization = this.defaultHeaders.Authorization;

      if (typeof Authorization !== 'string' || !Authorization.startsWith('Bearer ')) {
        return null;
      }

      return Authorization.replace('Bearer ', '');
    },
    set: function set(token) {
      if (!token) {
        // eslint-disable-next-line fp/no-delete
        delete this.defaultHeaders.Authorization;
        return;
      }

      this.defaultHeaders.Authorization = "Bearer ".concat(token);
    }
  }, {
    key: "basePath",
    get: function get() {
      return getBasePath({
        scheme: this.scheme,
        host: this.host,
        pathPrefix: this.pathPrefix
      });
    }
  }]);

  return NetlifyAPI;
}();
/* eslint-enable fp/no-this */


var getBasePath = function getBasePath(_ref5) {
  var scheme = _ref5.scheme,
      host = _ref5.host,
      pathPrefix = _ref5.pathPrefix;
  return "".concat(scheme, "://").concat(host).concat(pathPrefix);
}; // 1 second


var DEFAULT_TICKET_POLL = 1e3; // 1 hour

var DEFAULT_TICKET_TIMEOUT = 3.6e6;
module.exports = NetlifyAPI;
module.exports.methods = getOperations();